import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import CompFormContainer from "./compFormContainer";
import { useSalaryPermissions } from "components/salary";
//#endregion
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";

function useTimeReportingEventHandlers(changeMonthStatus: () => Promise<void>, reloadHandler?: () => void) {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { isSalaryDeviationsAvailable } = useSalaryPermissions();

  const displayCompDialog = (employeeId: number, changeMonthStatus: () => Promise<void>, startDate?: Date) => {
    const month = startDate && new Date(startDate).getMonth() + 1;
    const monthLong = LocalizationHelperInstance.getFormattedMessage(`Common.Month_${month}`);

    dispatch(
      displayDialog({
        isOpen: false,
        title: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.TimeReporting.SubmitAllowancesForMonth,
          "",
          {
            monthLong: monthLong,
          }
        ),
        subTitle: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.TimeReporting.SubmitAllowancesDescription
        ),
        dialogType: DialogEnums.DialogType.Content,
        titleIcon: IconDefinitionConstants.WDocument,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.LockMonth),
            successMessage: TranslationKeys.Document.CreateSuccess,
            onClick: () => changeMonthStatus(),
          },
        ],
        children: <CompFormContainer startDate={startDate} employeeId={employeeId}></CompFormContainer>,
        onSubmit: reloadHandler,
        maxWidth: "sm",
      })
    );
  };

  const onLockMonthClick = async (employeeId: number, startDate?: Date, updateWeek?: () => Promise<void>) => {
    updateWeek && (await updateWeek());

    if (startDate) {
      if (isSalaryDeviationsAvailable) {
        displayCompDialog(employeeId, changeMonthStatus, startDate);
      } else {
        await changeMonthStatus();
        reloadHandler && reloadHandler();
      }
    } else {
      reloadHandler && reloadHandler();
    }
  };

  return { onLockMonthClick };
}

export default useTimeReportingEventHandlers;
